import connect from '../connect';
import ACTIONS from '../../../store/actions';

function withUserInfo(WrappedComponent) {
  return connect(mapStateToProps, mapDispatchToProps, null, {
    pure: false
  })(WrappedComponent);
}

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    setAuth: function setAuth(userInfo) {
      return dispatch({
        type: ACTIONS.USER_INFO_GET_RESOLVED,
        payload: userInfo
      });
    }
  };
};
/**
 * @param {any} state
 * @returns {import('../types').WithUserInfo}
 */


var mapStateToProps = function mapStateToProps(state) {
  return {
    userInfo: state.userInfo
  };
};

export default withUserInfo;